import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  return <section className="w-full bg-secondary/30 py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-64">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-65"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-accent/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-66"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-67">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-68">
          {/* Left Column - Text Content */}
          <div className="text-center lg:text-left" data-id="element-69">
            <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-textDark leading-[1.15] mb-6" data-id="element-70">
              Aprende crochet desde cero y crea piezas que puedes{' '}
              <span className="text-primary italic" data-id="element-71">vender desde casa</span>
            </h1>

            <p className="font-heading text-xl md:text-2xl text-textLight italic mb-8" data-id="element-72">
              (aunque hoy no entiendas los patrones)
            </p>

            <div className="font-body text-lg md:text-xl text-textDark leading-relaxed mb-10 space-y-4" data-id="element-73">
              <p data-id="element-74">
                Descubre el método paso a paso que ya ayudó a cientos de mujeres
                a <b data-id="element-75">dejar la frustración</b>.
              </p>
              <p data-id="element-76">
                Empieza a crear tejidos hermosos <u data-id="element-77">desde el primer día</u>.
              </p>
            </div>

            <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-body font-bold text-lg px-12 py-5 rounded-full shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-78">
              COMPRAR AHORA
            </a>

            {/* Trust Badges */}
            <div className="mt-10 flex flex-col sm:flex-row justify-center lg:justify-start items-center gap-4" data-id="element-79">
              <div className="flex items-center gap-1 bg-white/50 px-4 py-2 rounded-full shadow-sm" data-id="element-80">
                <span className="text-accent text-lg" data-id="element-81">⭐⭐⭐⭐⭐</span>
                <span className="font-body text-sm font-semibold text-textDark ml-2" data-id="element-82">
                  +3.700 tejedoras satisfechas
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Hero Image */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-83">
            <div className="aspect-[4/5] rounded-[2rem] shadow-soft-lg overflow-hidden relative z-10 border-8 border-white" data-id="element-84">
              <img src="https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=800&h=1000&fit=crop" alt="Hermosos amigurumis tejidos a crochet" className="w-full h-full object-cover" data-id="element-85" />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white text-textDark font-body px-6 py-4 rounded-2xl shadow-soft-lg z-20 flex items-center gap-3" data-id="element-86">
              <div className="bg-primary/20 p-2 rounded-full" data-id="element-87">
                <span className="text-2xl" data-id="element-88">🧶</span>
              </div>
              <div data-id="element-89">
                <p className="font-bold text-lg leading-tight" data-id="element-90">+7.000</p>
                <p className="text-sm text-textLight" data-id="element-91">Patrones</p>
              </div>
            </div>

            {/* Decorative blob behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] bg-secondary rounded-full blur-2xl -z-10" data-id="element-92"></div>
          </div>
        </div>
      </div>
    </section>;
}